<div class="password-field">
	<input [formControl]="control" [type]="show ? 'text' : 'password'" class="custom-input" [placeholder]="placeholder" />
	<img class="show" *ngIf="!show" src="assets\profile\Icon ionic-md-eye.svg" (click)="toggleHide()" />
	<img class="hide" *ngIf="show" src="assets\profile\Icon ionic-md-eye-off.svg" (click)="toggleHide()" />
</div>
